import { render, staticRenderFns } from "./Mudancas-estudante.vue?vue&type=template&id=3d64212a&"
import script from "./Mudancas-estudante.vue?vue&type=script&lang=js&"
export * from "./Mudancas-estudante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports